import React from 'react'
import { Box, Grid, TextField } from '@mui/material'
import boxStyle from '../../styles/boxStyle'

function Cutomer({enquiryDetail}) {
  return (
    <Box sx={boxStyle.root} >
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6} >
        <TextField
          fullWidth
          size='small'
          label="Owner Name"
          variant="outlined"
          required
          name='owner'
          value={enquiryDetail.Customer?enquiryDetail.Customer: ''}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          size='small'
          label="Street Name"
          variant="outlined"
          required
          name='street'
          value={enquiryDetail.Street_Name?enquiryDetail.Street_Name: ''}
        />
      </Grid>
      <Grid item xs={12} sm={6} >
        <TextField
          fullWidth
          size='small'
          label="Postal Code"
          variant="outlined"
          required
          name='post'
          value={enquiryDetail.Post_Code?enquiryDetail.Post_Code: ''}
        />
      </Grid>
      <Grid item xs={12} sm={6} >
        <TextField
          fullWidth
          size='small'
          label="Addrss"
          variant="outlined"
          required
          name='address'
          value={enquiryDetail.Address?enquiryDetail.Address: ''}
        />
      </Grid>
      <Grid item xs={12} sm={6} >
        <TextField
          fullWidth
          size='small'
          label="Email ID"
          variant="outlined"
          required
          name='email'
          value={enquiryDetail.Email?enquiryDetail.Email: ''}
        />
      </Grid>
      <Grid item xs={12} sm={6} >
        <TextField
          fullWidth
          size='small'
          label="Mobile"
          variant="outlined"
          required
          name='mobile'
          value={enquiryDetail.Mob_No?enquiryDetail.Mob_No: ''}
        />
      </Grid>
    </Grid>
  </Box>
  )
}

export default Cutomer